import api from '../api';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

import { getJwt } from '@app/helpers';

const controller = "crfProjetoOverView";

export interface CrfTabelaProjetoOverViewBase {
    departamentoSigla: string;
    departamentoNome: string;
    areaSigla: string;
    areaNome: string;
    diretoriaSigla: string;
    diretoriaNome: string;
    nomeProjeto: string;
    codProjeto: string;
    index: number;
    id: string;
    nome: string;
    descricao: string;
    projetoId: string;
}

export interface CrfTabelaProjetoOverViewResult extends CrfTabelaProjetoOverViewBase {
    economicProgrAdEc: string;
    descricaoEconomicProgrAdEc: string;
    descricaoEconomicProgrActual: string;
    economicProgrActual: string;
    statusCapEx: boolean;
    economicProgrPlan: string;
    statusCompletion?: boolean;
    descricaoEconomicProgrPlan: string;
    status: boolean;
    capEx: string;
    contratado: string;
    executado: string;
    requisitado: string;
    compromissado: string;
    aContratar: string;
    forecast: string;
    saldo: string;
    progressoEconomicoPlan: string;
    progressoEconomicoAtual: string;
    progressoEconomicoAdEc: string;
    completionPlan: string;
    completionForecast: string;
    capExplan: string;
    capExForecast: string;

}

export interface CrfTabelaProjetoOverViewDetalhadoResult extends CrfTabelaProjetoOverViewBase {
    orcadoBaseline: string;
    orcadoRevisaoBl: string;
    orcadoForecast: string;

    mesPlan: string;
    mesReal: string;
    mesAlder: string;

    anoPlan: string;
    anoReal: string;
    anoAlder: string;

    pluriAnualPlan: string;
    pluriAnualReal: string;
    pluriAnualAlder: string;

    mesValorOrcado: string;
    mesValorExecutado: string;

    anoValorOrcado: string;
    anoValorExecutado: string;

    pluriAnualValorOrcado: string;
    pluriAnualValorExecutado: string;
}

export interface CrfInformacaoProjetoResult {
    cicloAno: number;
    scope: string;
    projetoId: string;
    metas: CrfMetas[];
    overView: CrfOverView[];
    graficoCiloAno: CrfGraficoRpp;
    graficoPluriAnual: CrfGraficoRpp
}

export interface CrfMetas {
    id: string;
    descricao: string,
    completion: string,
    capEx: string,
    statusCompletion?: boolean
}
export interface CrfOverView {
    id: string;
    progress: string,
    economicProgrPlan: string,
    economicProgrActual: string,
    economicProgrAdEc: string,
}

export interface CrfGraficoRpp {
    capEx: number;
    contHidden: number;
    execu: number;
    execuHidden: number;
    reqs: number;
    reqsHidden: number;
    toCont: number;
    forecast: number;
    balance: number;
}

export const getAllCrfProjetoOverView = () =>
    api.get<CrfTabelaProjetoOverViewResult[]>(`${controller}/getAllCrfProjetoOverView`);
export const getAllCrfProjetoOverViewDetalhado = () =>
    api.get<CrfTabelaProjetoOverViewDetalhadoResult[]>(`${controller}/getAllCrfProjetoOverViewDetalhado`);

export const exportaCrfRelatorioOverView = () => {
    let data = new Date();

    let dataFormatada = ((data.getDate())) + "_" + ((data.getMonth() + 1)) + "_" + data.getFullYear() + "_" + data.getHours() + "_" + data.getMinutes();

    let urlBase = window.location.origin;
    trackPromise(Axios.get(urlBase + `/api/${controller}/exportarRelatorioProjetoOver`,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Projects Overview Dashboard ${dataFormatada}.xlsx`);
            link.setAttribute('id', 'relatorioProjetoOveerView');
            document.body.appendChild(link);
            link.click();
            var el = document.getElementById('relatorioProjetoOveerView');

            if (el) {
                el.outerHTML = '';
            }
        }));
};
